<template>
    <div class="zq-popup zq-popup--visible">
        <div class="zq-popup__container">
            <div class="zq-popup__title">
                Merge coupons
                <div @click="closePopup()" class="zq-popup__close-button closePopup"
                     data-close-popup-id="activity-detail-popup"></div>
            </div>
            <div class="zq-popup__content custom-scroller">
                <p>Merging these {{coupons.length}} coupons will create a new coupon with the amount of <money-format :value="value"/> and the expiry date of {{expires|moment('LL')}}.</p>
                <p>Are you sure?</p>
            </div>
            <div class="zq-popup__bottom">
                <button @click="mergeCoupons()" class="button button--primary">Merge coupons</button>
                <button @click="closePopup()" class="button button--gray closePopup"
                        data-close-popup-id="choose-date-popup">Close
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    import MoneyFormat from "../../components/MoneyFormat";
    import axios from "axios";
    import { EventBus } from '../../event-bus.js';

    export default {
        name: 'MergeCoupons',
        components: {MoneyFormat},
        data() {
            return {
            }
        },
        computed: {
            coupons: function() {
                return this.popupPayload
            },
            value: function() {
                let sum = 0;
                for (let i=0; i<this.coupons.length; i++) {
                    sum += this.coupons[i].value;
                }
                return sum
            },
            expires: function() {
                let min = this.coupons[0].expires;
                for (let i=0; i<this.coupons.length; i++) {
                    if (this.coupons[i].expires<min)
                    min = this.coupons[i].expires
                }
                return min
            },
            codes: function() {
                let c = [];
                for (let i=0; i<this.coupons.length; i++) {
                    c.push(this.coupons[i].code)
                }
                return c;
            },
            ...mapState([
                'popupPayload',
            ])
        },
        methods: {
            mergeCoupons: async function() {
                let merge_url = process.env.VUE_APP_ZEEQUEST_URL + 'api/bbo/my-coupons/merge/';
                this.coupon = (await axios.post(merge_url, {'coupons':this.codes})).data
                EventBus.$emit('coupons-merged', this.coupon)
                this.closePopup()
            },
            ...mapActions([
                'closePopup'
            ])
        }
    }
</script>